<template>

  <div class="common-layout">
  <el-container>
    <el-header>
      <f-header/>
    </el-header>
    <el-container>
      <el-aside :width="store.asideWidth" :style="{height:'calc(100vh - 60px)'}">
        <f-menu/>
      </el-aside>
      <el-main >
        <f-nav-tag/>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
  </div>
</template>

<script setup>
import { useStore } from '~/store'
import FHeader from './components/FHeader.vue'
import FMenu from './components/FMenu.vue'
import FNavTag from './components/FNavTag.vue'

const store = useStore()
</script>

<style scoped>
.el-aside {
  transform: all 0.2s;
}
.common-layout .el-header {
  position: relative;
}
.el-main {
  height: calc(100vh - 60px);
  padding-top: 60px;
  overflow: auto;
  position: relative;
}
.common-layout .el-aside {
  height:calc(100vh - 60px);
  /* border-right:1px solid var(--el-color-primary); */
}
</style>
